'use client';

import { useMeasure } from 'react-use';
import { IMobileRectangleContainer } from '~/app/_containers/i-mobile-rectangle-container';
import {
  createDynamicElementId,
  I_MOBILE_PC_S_INREAD_RECTANGLE,
  I_MOBILE_PC_S_INREAD_RECTANGLE_SENSITIVE,
  I_MOBILE_SP_S_INREAD_RECTANGLE,
  I_MOBILE_SP_S_INREAD_RECTANGLE_SENSITIVE,
} from '~/utils/i-mobile-constants';
import { css } from '@styled-system/css';
import { Box, Center, VStack } from '@styled-system/jsx';
import type { InReadAdContainerProps } from './types';

type Props = InReadAdContainerProps;

export const InReadIMobileAdContainer = ({
  adIndex,
  canShowGoogleAd,
  ...props
}: Props) => {
  const [adContainerRef, { height }] = useMeasure<HTMLDivElement>();

  return (
    <VStack
      mt="4"
      w="100%"
      gap="2"
      zIndex={1}
      style={{
        padding: height > 0 ? '8px 0' : undefined,
      }}
      {...props}
    >
      {height > 0 && (
        <Center
          w="90%"
          position="relative"
          _before={{
            position: 'absolute',
            top: '50%',
            left: 0,
            width: '100%',
            height: '1px',
            background: 'separator',
            content: '""',
          }}
        >
          <span
            className={css({
              bg: 'strong_bg',
              px: 4,
              color: 'accent.700',
              fontSize: 'xs',
              zIndex: 1,
            })}
          >
            広告
          </span>
        </Center>
      )}
      <Box ref={adContainerRef}>
        <IMobileRectangleContainer
          spAdUnit={createDynamicElementId(
            canShowGoogleAd
              ? I_MOBILE_SP_S_INREAD_RECTANGLE
              : I_MOBILE_SP_S_INREAD_RECTANGLE_SENSITIVE,
            `scene-${adIndex}`
          )}
          pcAdUnit={createDynamicElementId(
            canShowGoogleAd
              ? I_MOBILE_PC_S_INREAD_RECTANGLE
              : I_MOBILE_PC_S_INREAD_RECTANGLE_SENSITIVE,
            `scene-${adIndex}`
          )}
        />
      </Box>
    </VStack>
  );
};
